import { render, staticRenderFns } from "./TikHubOperatorSettings.vue?vue&type=template&id=64989d42&scoped=true&"
import script from "./TikHubOperatorSettings.vue?vue&type=script&lang=js&"
export * from "./TikHubOperatorSettings.vue?vue&type=script&lang=js&"
import style0 from "./TikHubOperatorSettings.vue?vue&type=style&index=0&id=64989d42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64989d42",
  null
  
)

export default component.exports